/**
 * ADR-0213 ruling 84 — Atlas Query is a switch on the person. The console
 * shows it (the nav entry, the page) only to a builder or an admin it is
 * switched on for; anything else — a viewer, the switch off, an answer that
 * does not say — is closed. The hub refuses every Atlas Query route the same
 * way, so this decides only what the person is shown.
 */
export function atlasQueryOpen(entitlement: string | undefined, atlasQuery: unknown): boolean {
  return (entitlement === "builder" || entitlement === "admin") && atlasQuery === true;
}
